export interface IBoundary {
  type: string;
  geometry: {
    type: string;
    coordinates: number[][][];
  };
  properties: {
    id: number;
    area: number;
  };
}

export interface ICentroid {
  type: string;
  geometry: {
    type: string;
    coordinates: number[][];
  };
  properties: {
    id: number;
  };
}

export interface IFieldDetails {
  name: string;
  farmerId: string;
  landTypeId: string;
  fieldIdentificationNumber: string;
  landNumber: string;
  address: string;
  village: string;
  subDistrict: string;
  district: string;
  province: string;
  postalCode: string;
  mediaFileId: string;
  mapFileId: string;
  boundary: IBoundary;
  centroid: ICentroid;
  isPinnedLocation: boolean;
  totalAreaUser: number;
  totalAreaUserUnit: "HECTARE" | string;
  factoryId: string;
  documentFileId: string;
  // R4a — optional dealer/branch linkage (UUIDs or null)
  dealerId?: string | null;
  branchId?: string | null;
}

export enum ELandPlotTypes {
  locationPinning = "Location Pinning",
  preciseMapping = "Precise Mapping",
}
